export const GIVONIC = {
  variable: 'Givonic Variable',
  black: 'Givonic-Black',
  bold: 'Givonic-Bold',
  light: 'Givonic-Light',
  regular: 'Givonic-Regular',
  semiBold: 'Givonic-SemiBold',
  thin: 'Givonic-Thin',
}

export const INTER = {
  black: 'Inter-Black',
  bold: 'Inter-Bold',
  extraBold: 'Inter-ExtraBold',
  extraLight: 'Inter-ExtraLight',
  light: 'Inter-Light',
  medium: 'Inter-Medium',
  regular: 'Inter-Regular',
  semiBold: 'Inter-SemiBold',
  thin: 'Inter-Thin',
}